import { useSmtpConfiguration } from "@/hooks/useSmtpConfiguration";
import SmtpConfigurationForm from "./components/SmtpConfigurationForm";

export default function SmtpConfigurationPage() {
  const { smtpConfiguration, loading: queryLoading, refetch } = useSmtpConfiguration();

  return (
    <div className="container-elegant py-24">
      <div className="mb-12">
        <h1 className="text-3xl font-light tracking-tight text-primary-950 dark:text-white">
          Configuração SMTP
        </h1>
        <p className="mt-2 text-primary-600 dark:text-primary-400">
          Configure as definições de servidor de e-mail do aplicativo
        </p>
      </div>

      <SmtpConfigurationForm
        key={smtpConfiguration?.id || "new"}
        initialData={smtpConfiguration}
        onSaved={refetch}
        isQueryLoading={queryLoading}
      />
    </div>
  );
}
